module.exports = __webpack_public_path__ + "static/media/play.f4192c06.svg";